import { render, staticRenderFns } from "./MainLogo.vue?vue&type=template&id=e6d19292&"
import script from "./MainLogo.vue?vue&type=script&lang=js&"
export * from "./MainLogo.vue?vue&type=script&lang=js&"
import style0 from "./MainLogo.vue?vue&type=style&index=0&id=e6d19292&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports